module.exports = __webpack_public_path__ + "fonts/Lato-SemiboldItalic.9fcec04c.woff";